import React, { createContext } from "react";

// Skeleton of the app data
/*
    user: {},
    agroEcoData: {},
    contextScores: {},
    pairWiseScores: {},
    participatoryMatrixScores: {},
    results: {},
*/

// Creating the app context to be used with the react contextapi
const AppContext = createContext();

export default AppContext;
